var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFilterBigMobile = function SvgFilterBigMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.959 18.677v-4.83c0-.742.265-1.46.748-2.023l7.244-8.45H3.049l7.243 8.45c.483.563.749 1.28.749 2.022v6.048l1.918-1.217zm2-4.83c0-.265.095-.52.267-.721l8.505-9.923c.616-.72.105-1.83-.841-1.83H1.11c-.946 0-1.457 1.11-.841 1.83l8.505 9.922c.172.2.267.457.267.721v7.67c0 .874.964 1.404 1.702.936l3.701-2.349c.32-.203.515-.556.515-.936v-5.32z",
    fill: "#004152"
  })));
};

export default SvgFilterBigMobile;